import { useSelector } from "react-redux";
import { useGetScrapItemByUserQuery, useGetSingleItemByUserQuery } from "../../features/shop/shopApiSlice";
import { useGetUserPropertiesQuery } from "../../features/property/propertyApiSlice";
import { useGetCvExistQuery } from "../../features/user/userApiSlice";

const useBusinessModeData = () => {
  const { name } = useSelector((state) => state.user);
  const userId = name?._id;

  const { data: scrapRes } = useGetScrapItemByUserQuery(userId, {
    skip: !userId,
  });
  const { data: singleRes } = useGetSingleItemByUserQuery(userId, {
    skip: !userId,
  });
  const { data: propertiesRes } = useGetUserPropertiesQuery(
    userId ? { userid: userId } : undefined,
    { skip: !userId },
  );
  const { data: cvRes } = useGetCvExistQuery(userId, {
    skip: !userId,
    refetchOnMountOrArgChange: true,
  });

  const hasCv = Boolean(cvRes?.cvform || cvRes?.success);

  return {
    userId,
    scrapform: scrapRes?.data?.ShopItems || [],
    singleform: singleRes?.data?.ShopItems || [],
    personalform: propertiesRes?.data?.Companies || [],
    cvform: hasCv ? (cvRes?.cvform?._id || "exists") : "",
  };
};

export default useBusinessModeData;
